export default __webpack_public_path__ + "static/media/logo_without_boxshadow.714aeef9.png";